import { Component } from "react";
import { connect } from "react-redux";

class SPINNER extends Component {
  render() {
    const {
      unik,
      width = 40,
      border = 3,
      marginTop = "0px",
      center = false,
      color1 = "rgb(156, 212, 255)", // default border color
      color2 = "#1e5e96ff", // default border-top color
    } = this.props;

    return (
      <div className={`loader${unik}`}>
        <style>
          {`
  .loader${unik} {
    display: inline-block;
    vertical-align: middle;
    border: ${width * border}px solid ${color1};
    border-radius: 50%;
    border-top: ${width * border}px solid ${color2};
    width: ${width}px;
    height: ${width}px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
    margin-top: ${marginTop};
    ${center ? "margin:auto;" : ""}
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
          `}
        </style>
      </div>
    );
  }
}

SPINNER.defaultProps = {
  width: 40,
  border: 3,
  marginTop: "0px",
  center: false,
  color1: "rgb(156, 212, 255)",
  color2: "#1e5e96ff",
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(SPINNER);
